export enum QueryKeys {
  text = "text",
  list = "list",
  image = "image",
  user = "user",
}

export enum RouteActions {
  add = "add",
  edit = "edit",
}

export enum PathNames {
  base = "/dashboard",
}
